import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AuthPage from "./pages/AuthPage";
import AppPage from "./pages/AppPage";
import ProfilePage from "./pages/ProfilePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import BoardPage from "./pages/BoardPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import InvitePage from "./pages/InvitePage";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { BoardProvider } from "./contexts/BoardContext";

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) {
    // Blank screen during initial auth check (per user preference)
    return <div style={{ height: "100vh", backgroundColor: "#f8fafc" }} />;
  }

  return (
    <Routes>
      <Route path="/privacy-copy" element={<PrivacyPolicyPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      {/*
        /invite/:code is the universal-link target. iOS routes it to the
        installed app via apple-app-site-association; the page renders only
        as a fallback for users without the app, on desktop, or while AASA
        is still verifying after a fresh install. Intentionally
        unauthenticated.
      */}
      <Route path="/invite/:code" element={<InvitePage />} />
      <Route path="/" element={user ? <Navigate to="/app" replace /> : <AuthPage />} />
      <Route path="/app" element={user ? <AppPage /> : <Navigate to="/" replace />} />
      <Route path="/board/:boardId" element={user ? <BoardPage /> : <Navigate to="/" replace />} />
      <Route path="/profile" element={user ? <ProfilePage /> : <Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BoardProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </BoardProvider>
    </AuthProvider>
  );
}